import React, { useState } from "react";
import { register } from "../services/auth";
import { useNavigate } from "react-router-dom";
import "@tabler/core/dist/css/tabler.min.css";

function Register() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    username: "",
    email: "",
    password: "",
    password2: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (userData.password !== userData.password2) {
      alert("As senhas não correspondem");
      return;
    }
    try {
      await register(userData);
      alert("Registrado com sucesso");
      navigate("/login");
    } catch (error) {
      alert("Erro ao registrar");
    }
  };

  return (
    <div className="page">
      <div
        className="container-tight py-4"
        style={{ maxWidth: "400px", margin: "0 auto" }}
      >
        <form className="card card-md" onSubmit={handleSubmit}>
          <div className="card-body">
            <h2 className="card-title text-center mb-4">Registrar</h2>
            <div className="mb-3">
              <label className="form-label">Usuário</label>
              <input
                type="text"
                className="form-control"
                placeholder="Digite seu usuário"
                value={userData.username}
                onChange={(e) =>
                  setUserData({ ...userData, username: e.target.value })
                }
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">E-mail</label>
              <input
                type="email"
                className="form-control"
                placeholder="Digite seu e-mail"
                value={userData.email}
                onChange={(e) =>
                  setUserData({ ...userData, email: e.target.value })
                }
                required
              />
            </div>
            <div className="mb-2">
              <label className="form-label">Senha</label>
              <input
                type="password"
                className="form-control"
                placeholder="Digite sua senha"
                value={userData.password}
                onChange={(e) =>
                  setUserData({ ...userData, password: e.target.value })
                }
                required
              />
            </div>
            <div className="mb-2">
              <label className="form-label">Confirme a Senha</label>
              <input
                type="password"
                className="form-control"
                placeholder="Confirme sua senha"
                value={userData.password2}
                onChange={(e) =>
                  setUserData({ ...userData, password2: e.target.value })
                }
                required
              />
            </div>
            <div className="form-footer">
              <button type="submit" className="btn btn-primary w-100">
                Registrar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;